const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class LoyaltyProductRecs extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['carousel']
  }

  constructor () {
    super()

    this.carouselContainer = this.els.carousel.element
    this.handleTagalysReady = this.buildProductCards.bind(this)

    this.tagalysEventTimeout()
  }

  setupListeners () {
    // Await the Tagalys Init function, found within `tagalys.liquid`
    document.addEventListener('tagalysReady', this.handleTagalysReady)
  }

  /**
   * Build product cards
   */
  async buildProductCards () {
    if (!this.carouselContainer || !this.dataset.tagalysSmartWidgetId) {
      this.removeSection()
      return
    }

    // Product Recs data
    let productRecsData = false
    try {
      productRecsData = await this.fetchProductData()
    } catch (error) {
      console.error(error)
    }

    if (
      !productRecsData ||
      !productRecsData.products ||
      !productRecsData.products > 0 ||
      productRecsData.status === 'Not found'
    ) {
      this.removeSection()
    } else {
      // Extract product handles
      const productHandles = Object.values(productRecsData.products).map(
        product => product.handle,
      )
      this.buildCarousel(productHandles)
    }
  }

  async fetchProductData () {
    return new Promise((resolve, reject) => {
      window.Tagalys.APIConnector.SmartWidget.call({
        params: {
          widgetId: this.dataset.tagalysSmartWidgetId,
        },
        onSuccess (response) {
          resolve(response) // Resolve the promise with the response data
        },
        onFailure (response) {
          reject(response)
        },
      })
    })
  }

  /**
   * Build Carousel
   */
  async buildCarousel (productHandles = []) {
    let carouselItemMarkupString = ''

    if (!productHandles || !productHandles.length >= 1) {
      console.error(
        'Attempted to build carousel but failed due to missing data',
      )
      return
    }

    try {
      const fetchPromises = productHandles.map(async (handle, index) => {
        const url = `${
          window.Shopify.routes.root
        }products/${handle}/index-${index}?${new URLSearchParams({
          view: 'card',
        }).toString()}`
        return this.fetchProductCardMarkup(url)
      })

      const productCardMarkups = await Promise.all(fetchPromises)

      productCardMarkups.forEach(markup => {
        if (markup) {
          carouselItemMarkupString += `
            <div class="loy-ProductRecs_CarouselSlide" data-loyalty-product-recs-el="slide">
              ${markup}
            </div>
          `
        }
      })

      this.carouselContainer.innerHTML = carouselItemMarkupString

      this.initaliseCarousel()
    } catch (error) {
      console.error(error)
    }
  }

  async fetchProductCardMarkup (url) {
    try {
      const response = await fetch(url)
      return await response.text()
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  initaliseCarousel () {
    const carouselContainer = this.els.carousel.element
    const carouselItems = carouselContainer.querySelectorAll(
      '[data-loyalty-product-recs-el="slide"]',
    )

    if (carouselItems.length <= 2) {
      carouselContainer.setAttribute('data-center-mobile', true)
    }
    if (carouselItems.length <= 6) {
      carouselContainer.setAttribute('data-center-desktop', true)
    }

    return new KeenSlider(
      carouselContainer,
      {
        selector: carouselItems,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.5,
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 6,
              spacing: 10,
            },
          },
        },
      },
      [setInitialised()],
    )
  }

  tagalysEventTimeout () {
    const hideElement = () => {
      this.removeSection()
      clearTimeout(timeoutId)
    }

    const eventListener = () => {
      clearTimeout(timeoutId)
      document.removeEventListener('tagalysReady', eventListener)
    }

    const timeoutId = setTimeout(hideElement, 10000)

    document.addEventListener('tagalysReady', eventListener)
  }

  removeSection () {
    document
      .querySelector('[data-section-type="loyalty-lp-product-recs"]')
      ?.remove()
  }
}

if (!customElements.get('loyalty-product-recs')) {
  customElements.define('loyalty-product-recs', LoyaltyProductRecs)
}
